module.exports = __webpack_public_path__ + "img/vip.acd1744e.png";